import { put, call, takeEvery } from 'redux-saga/effects';
import { axiosInstance, apiURL } from 'config';
import toast from 'react-hot-toast';

import {
  loadReviewsRequested,
  loadReviewsSuccess,
  loadReviewsFail,
  updateReviewsRequested,
  updateReviewsSuccess,
  updateReviewsFail,
} from './reviewsSlice';

export function* loadReviewsEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/index-review?searchString=${
        action?.payload?.filters?.query ?? ''
      }&page=${action.payload.page}&pageSize=${action.payload.perPage}`
    );
    yield put(loadReviewsSuccess(data));
  } catch (error: any) {
    yield put(loadReviewsFail(error.message));
  }
}

function* updateReviewsEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.put,

      `${apiURL}/changed-review-status?id=${action?.payload?.id}&status=${action?.payload?.status?.id}`
    );
    if (data?.succeeded) {
      yield put(updateReviewsSuccess(data));
      toast.success('Review status updated successfully');
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(updateReviewsFail(error.message));
  }
}

export function* reviewsSaga(): Generator<any, void, any> {
  yield takeEvery(loadReviewsRequested, loadReviewsEffect);
  yield takeEvery(updateReviewsRequested, updateReviewsEffect);
}
